import {
    Box,
    Grid,
    Paper,
    Typography,
    Button,
    TextField,
    LinearProgress,
    Divider,
    Stack,
    Tooltip,
    CircularProgress,
    Modal,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    FormControl,
    FormControlLabel
} from "@mui/material";
import oceshaLogo from '../../../assets/ocesha_images/ocesha_logo.png';
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import { useLocation, useNavigate } from "react-router-dom";
import { useLazyGetProductQuery } from "redux/api/productApi";
import { useState, useEffect, ChangeEvent } from "react";
import { useAppSelector, useAppDispatch } from "redux/store";
import { toast } from "react-toastify";
import { removeCookie } from "utils/storageUtils";
import { logout } from "redux/features/userSlice";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { useRef } from "react";
import WestIcon from '@mui/icons-material/West';
import axios from "axios";
import { useGetUserDetailsMutation } from "redux/api/authApi";
import { isMobile } from "react-device-detect";
import CloseIcon from '@mui/icons-material/Close';
import unsplashImg from '../../../assets/traffic_monster/unsplash_logo.png';
import ComputerIcon from '@mui/icons-material/Computer';
import SearchIcon from '@mui/icons-material/Search';
import unsplash_logo from '../../../assets/traffic_monster/unsplash_logo.png';
import GBALogo from '../../../assets/traffic_monster/GBA_Logo.png';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { marked } from "marked";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface UnsplashImage {
    id: string;
    urls: {
        thumb: string;
        regular: string;
    };
    alt_description: string;
    width: number;
    height: number;
}

const createCourseSlug = (
    title: string,
    id: string
) => {
    const slug = title
        ?.toLowerCase()
        ?.trim()
        ?.replace(/[^a-z0-9\s-]/g, "")
        ?.replace(/\s+/g, "-");

    return `${slug}-${id}`;
};

export default function CourseEditorScreen() {

    const navigate = useNavigate();
    const location = useLocation();
    const [activeItem, setActiveItem] = useState(localStorage.getItem('activeItem') || 'dashboard');
    const genieSelector = useAppSelector((state) => state.genieState);
    const [getProduct, getProductState] = useLazyGetProductQuery();
    const dispatch = useAppDispatch();
    /* const [title, setTitle] = useState(
        "Speak & Play: Transforming Speech Therapy Access"
    ); */
    /* const [title1, setTitle1] = useState("The Market Crisis");
    const [desc1, setDesc1] = useState(
        "Over 80 million children globally face speech and language delays, yet severe shortages of speech-language pathologists create months-to-years waitlists. Limited early intervention access leaves families struggling during critical developmental windows."
    ); */
    const [getUserDetailsMutation] = useGetUserDetailsMutation();
    const [curriculum, setCurriculum] = useState<any[]>([]);
    const [activeWeekIndex, setActiveWeekIndex] = useState(0);
    const [courseImage, setCourseImage] = useState<any>();
    const [courseDetails, setCourseDetails] = useState<any>();
    const [updatingCourseDet, setUpdatingCourseDet] = useState<boolean>(false);
    const [loadingCourse, setLoadingCourse] = useState<boolean>(true);
    const [instructorDetails, setInstructorDetails] = useState({
        profileImage: null as File | null,
        profileImagePreview: "",
        existingImageUrl: "",
        profileUrl: "",
        profileUrl1: "",
        ctaLabel: "",
        ctaUrl: "",
        introVideo: null as File | null,
        introVideoPreview: "",
    });
    const videoInputRef = useRef<HTMLInputElement | null>(null);
    const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);

    const [title1, setTitle1] = useState('');
    const [desc1, setDesc1] = useState('');
    const [moduleLearningObjectives, setModuleLearningObjectives] = useState<string[]>(['']);
    const [mainTitle, setMainTitle] = useState('');
    const [coursePrice, setCoursePrice] = useState<any>();
    const [courseDescription, setCourseDescription] = useState<any>();
    const [courseTargetAudi, setCourseTargetAudi] = useState<any>();
    const [learner, setLearner] = useState<any>();
    const [courseDuration, setCourseDuration] = useState<any>();
    const [courseLearningOutcomes, setCourseLearningOutcomes] = useState<any>();
    const [priceType, setPriceType] = useState<string>("paid");
    const [userDetails, setUserDetails] = useState<any>();
    const [showUnsplash, setShowUnsplash] = useState(false);
    const [unsplashImages, setUnsplashImages] = useState<any[]>([]);
    const [selectedUnsplashImage, setSelectedUnsplashImage] = useState<string>("");
    // const [unsplashSearch, setUnsplashSearch] = useState("online course");
    const useremail = localStorage.getItem('user_email') || '';
    const [choosingImageModal, setChoosingImageModal] = useState<boolean>(false);
    const [openUnsplash, setOpenUnsplash] = useState<any>();
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [query, setQuery] = useState('');
    const [images, setImages] = useState<UnsplashImage[]>([]);
    const [unsplashSearch, setUnsplashSearch] = useState<boolean>(false);
    const [selectedUnsplashImg, setSelectedUnsplashImg] = useState(null);
    const [GBAUserLogo, setGBAUserLogo] = useState<any>();


    const [image, setImage] = useState(
        "https://images.unsplash.com/photo-1601582589907-f92af5ed9db8"
    );

    const fileRef = useRef<HTMLInputElement>(null);

    const courseId = location.state?.courseId || null;
    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const hasFetched = useRef(false);

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'align': '' }, { 'align': 'center' }, { 'align': 'right' }, { 'align': 'justify' }],
        ],
    };

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        localStorage.removeItem('campaignid');
        localStorage.removeItem('returningtocampaign');
        localStorage.removeItem('sourceurl');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('paymentOption');
        localStorage.removeItem('autoPublish');
        localStorage.removeItem('limitPublish');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('addTags');
        localStorage.removeItem('captureLeads');
        localStorage.removeItem('newsLetter');
        localStorage.removeItem('twitterBtn');
        localStorage.removeItem('fbBtn');
        localStorage.removeItem('pintrestBtn');
        localStorage.removeItem('linkedinBtn');
        localStorage.removeItem('video');
        localStorage.removeItem('twitterurl');
        localStorage.removeItem('fburl');
        localStorage.removeItem('pintresturl');
        localStorage.removeItem('linkedinurl');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('owndomain');
        localStorage.removeItem('ChangepayMode');
        localStorage.removeItem('IdChangingMode');
        localStorage.removeItem('PaymentSubscription');
        localStorage.removeItem('Authorurl');
        localStorage.removeItem('Authorname');
        localStorage.removeItem('authorDefaultCheck');
        localStorage.removeItem('videoTag');
        localStorage.removeItem('podcastUrl');
        localStorage.removeItem('sourcetext');
        setActiveItem(localStorage.getItem('activeItem') ? localStorage.getItem('activeItem') : itemName);
        navigate('/codegenie/generated-blogs');
        if (itemName === 'upgrade') {
            const value = {
                _id: "",
                product_name: "CodeGenie",
                product_module: genieSelector.module ? genieSelector.module : "",
                userid: "",
                productid: ""
            };
            getProduct(value);
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { campIdFromUpgrade: localStorage.getItem('campId') || ''/* selectedCampaign */, from_page: 'blog_listing' } });
        } else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            //console.log("loggedin:" + localStorage.getItem("logged_in"));
            dispatch(logout());
            var module = localStorage.getItem("module");
            console.log("module111...." + module);

            toast.success("Logout success");
            // localStorage.removeItem("payment");
            localStorage.removeItem("msg");
            localStorage.removeItem("complexity");
            localStorage.removeItem("module");
            localStorage.removeItem("subscription_level");
            localStorage.removeItem("free_plan");
            // localStorage.removeItem("userRole");
            localStorage.removeItem("localStorage_msg");
            localStorage.removeItem("allSet");
            localStorage.removeItem("Blogs Generated");
            localStorage.removeItem("remaining_wish_count");
            localStorage.removeItem("userRole");
            localStorage.removeItem("payment");
            localStorage.removeItem("user_email");
            localStorage.removeItem("logged_in");
            localStorage.removeItem("prevImg");
            localStorage.removeItem("fromUpgrade");
            localStorage.removeItem("blogsCount");
            localStorage.removeItem("Generating Count");
            localStorage.removeItem("finalData");
            localStorage.removeItem("user_pass");
            localStorage.removeItem("fromNewcampaign");
            localStorage.removeItem("campaignid");
            localStorage.removeItem("returningtocampaign");
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('campId');
            localStorage.removeItem('campaignid');
            localStorage.removeItem('returningtocampaign');
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('smUrlpublish');
            localStorage.removeItem('addTags');
            localStorage.removeItem('captureLeads');
            localStorage.removeItem('newsLetter');
            localStorage.removeItem('twitterBtn');
            localStorage.removeItem('fbBtn');
            localStorage.removeItem('pintrestBtn');
            localStorage.removeItem('linkedinBtn');
            localStorage.removeItem('video');
            localStorage.removeItem('twitterurl');
            localStorage.removeItem('fburl');
            localStorage.removeItem('pintresturl');
            localStorage.removeItem('linkedinurl');
            localStorage.removeItem('owndomain');
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            localStorage.removeItem('user_name');
            localStorage.removeItem('refreshCount');
            localStorage.removeItem('publishingCampId');
            localStorage.removeItem('Authorurl');
            localStorage.removeItem('Authorname');
            localStorage.removeItem('authorDefaultCheck');
            localStorage.removeItem('appsumo_coupon_code');
            localStorage.removeItem('podcastUrl');
            localStorage.removeItem('AlertMessage');
            localStorage.removeItem('CreatingfromLanding');
            localStorage.removeItem('UrlfromLanding');
            localStorage.removeItem('signedup');
            localStorage.removeItem('uploadedvideo');
            localStorage.removeItem('uploadedVideoName');
            localStorage.removeItem('uploadStatus');
            localStorage.removeItem('editedposthashtags');
            localStorage.removeItem('editedpostblogsummary');
            localStorage.removeItem('editedpostblogtitle');
            localStorage.removeItem('editedposturl');
            localStorage.removeItem('user_email');
            localStorage.removeItem('YoutubeUrlfromLanding');
            localStorage.removeItem('FirstLogin');
            localStorage.removeItem('DirectSignup');
            localStorage.removeItem('FromIndexPage');
            localStorage.removeItem('activeItem');
            localStorage.removeItem('UpdateduserImage');
            localStorage.removeItem('FromEditBlog');
            localStorage.removeItem('ErrorAlert');
            localStorage.removeItem('FromSignIn');
            removeCookie('user_email');
            localStorage.clear();

            if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
                navigate("/Anycode_landing");
            else
                window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN || ''; //"https://ocesha.ai";
        }
    };

    /* const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setImage(URL.createObjectURL(file));
    }; */
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const img = new Image();

        img.onload = () => {
            const ratio = img.width / img.height;
            const expectedRatio = 3 / 2;

            // Allow ~5% tolerance
            if (Math.abs(ratio - expectedRatio) > 0.05) {
                toast.warning(
                    "This image is not in the recommended 3:2 aspect ratio (1080 × 720 px). It can still be uploaded, but it may appear cropped or stretched."
                );
            }


            setSelectedImageFile(file);

            // preview
            const previewUrl = URL.createObjectURL(file);
            setCourseImage(previewUrl);


            // update only current week
            setCurriculum((prev) => {
                const copy = [...prev];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    chapter_image_file: file,
                    chapter_image_url: previewUrl,
                };

                return copy;
            });

            setChoosingImageModal(false)
        }
        img.src = URL.createObjectURL(file);
    };

    useEffect(() => {
        if (!courseId) {
            toast.error('Something went wrong, Please try again later!');
            setLoadingCourse(false);
            return;
        }

        if (hasFetched.current) return;

        hasFetched.current = true;
        getCourseDetail();
    }, [courseId]);

    /* const convertContentToHtml = (content: string) => {
        if (!content) return "";

        // Already HTML from ReactQuill
        if (
            content.includes("<p") ||
            content.includes("<h") ||
            content.includes("<ul") ||
            content.includes("<ol") ||
            content.includes("<strong")
        ) {
            return content;
        }

        // Markdown from backend
        return marked.parse(content) as string;
    }; */
    const convertContentToHtml = (content: string) => {
        if (!content) return "";

        const hasHtml = /<(p|h[1-6]|ul|ol|li|strong|em|u|a|br|blockquote)\b/i.test(
            content
        );

        if (hasHtml) {
            return content;
        }

        return marked.parse(content) as string;
    };

    const normalizePriceType = (value: any) => {
        if (!value) return "paid";

        const type = String(value).toLowerCase();

        if (type === "free" || type === "free_course" || type === "0") {
            return "free";
        }

        return "paid";
    };

    const getCourseDetail = async () => {
        try {
            setLoadingCourse(true);

            const res = await axios.get(`${apiUrl}/api/prompts/get_course/${courseId}`);

            console.log('edit course detail response=>', res?.data);
            setCourseDetails(res?.data?.course);
            const course = res?.data?.course;
            const courseSlug = createCourseSlug(
                course?.title || "",
                course?._id || ""
            );

            const courseShareUrl =
                `${window.location.origin}/course/${courseSlug}`;
            setInstructorDetails(prev => ({
                ...prev,
                profileUrl: course?.social_url || "",
                profileUrl1: courseShareUrl,
                ctaLabel: course?.cta_lable || "", // (API typo handled)
                ctaUrl: course?.cta_url || "",
                introVideoPreview: course?.video_url
                    /* ? `${apiUrl}${course.video_url}`
                    : */ || "",
                existingImageUrl: course?.user?.user_image || "",
                profileImage: course?.user?.user_image
            }));
            const list = res?.data?.course?.curriculum || [];

            setCurriculum(list);
            setMainTitle(res?.data?.course?.title);
            setPriceType(normalizePriceType(res?.data?.course?.price_type));
            setCoursePrice(res?.data?.course?.suggested_price);
            setCourseDescription(res?.data?.course?.description);
            setCourseTargetAudi(res?.data?.course?.target_audience);
            setLearner(res?.data?.course?.difficulty);
            setCourseDuration(res?.data?.course?.course_definition?.total_duration);
            setCourseLearningOutcomes(res?.data?.course?.learning_outcomes);
            console.log('main title res =>', res?.data?.course?.title);
            setActiveWeekIndex(0);
            // setCourseImage(res?.data?.course?.image_path_small);

            if (list.length > 0) {
                setTitle1(list[0].title || '');
                // setDesc1((list[0].content).replace(/[*#]+/g, "") || '');
                setDesc1(convertContentToHtml(list[0].content || ''));
                setCourseImage(list[0]?.chapter_image || '');
                setModuleLearningObjectives(
                    Array.isArray(list[0]?.module_learning_objectives) && list[0].module_learning_objectives.length > 0
                        ? list[0].module_learning_objectives
                        : ['']
                );
            }
            /* if (list.length > 0) {
                setTitle1(list[0].title || '');
                setDesc1(list[0].content || '');
            } */
        } catch (error: any) {
            console.log('Error fetching course detail=>', error);
            toast.error(error);
        } finally {
            setLoadingCourse(false);
        }
    };

    useEffect(() => {
        return () => {
            if (instructorDetails.profileImagePreview) {
                URL.revokeObjectURL(instructorDetails.profileImagePreview);
            }
        };
    }, [instructorDetails.profileImagePreview]);

    const uploadInstructorProfileImage = async () => {
        if (!instructorDetails.profileImage) return;
        try {
            const imgFormData = new FormData();
            imgFormData.append('first_name', userDetails?.first_name || '');
            imgFormData.append('last_name', userDetails?.last_name || '');
            imgFormData.append('email', useremail);
            imgFormData.append('user_image', instructorDetails.profileImage);

            const imgRes = await axios.post(apiUrl + '/api/auth/updateUserSettings', imgFormData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (imgRes.data.user_image) {
                const newImg = imgRes.data.user_image + '?' + Math.random();
                setInstructorDetails(prev => ({ ...prev, existingImageUrl: newImg }));
                localStorage.setItem('UpdateduserImage', newImg);
                await fetchData();
                window.dispatchEvent(new Event("profileUpdated"));
                // window.dispatchEvent(new Event('storage'));
            }
        } catch (err) {
            console.error('Instructor image upload error:', err);
            toast.error('Failed to update profile image');
        }
    };

    const videoSrc = instructorDetails.introVideo
        ? instructorDetails.introVideoPreview // blob
        : instructorDetails.introVideoPreview
            ? `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${instructorDetails.introVideoPreview}`
            : "";

    useEffect(() => {
        if (!curriculum.length) return;

        const current = curriculum[activeWeekIndex];

        setTitle1(current?.title || '');
        // setDesc1((current?.content).replace(/[*#]+/g, "") || '');
        setDesc1(convertContentToHtml(current?.content || ''));
        console.log('course details=>', current?.content);
        // setDesc1(current?.content || '');

        // weekwise image
        // setCourseImage(current?.chapter_image_url || current?.chapter_image || '');
        setCourseImage(
            current?.chapter_image_preview ||
            current?.chapter_image_url ||
            current?.chapter_image ||
            ''
        );

        setModuleLearningObjectives(
            Array.isArray(current?.module_learning_objectives) && current.module_learning_objectives.length > 0
                ? current.module_learning_objectives
                : ['']
        );

    }, [activeWeekIndex/* , curriculum */]);

    // ------------------------------------------------
    // Module Learning Objectives handlers
    // ------------------------------------------------
    const handleObjectiveChange = (index: number, value: string) => {
        setModuleLearningObjectives((prev) => {
            const updated = [...prev];
            updated[index] = value;

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: updated,
                };

                return copy;
            });

            return updated;
        });
    };

    const handleAddObjective = () => {
        setModuleLearningObjectives((prev) => {
            const updated = [...prev, ''];

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: updated,
                };

                return copy;
            });

            return updated;
        });
    };

    const handleRemoveObjective = (index: number) => {
        setModuleLearningObjectives((prev) => {
            const updated = prev.filter((_, i) => i !== index);
            const finalUpdated = updated.length > 0 ? updated : [''];

            setCurriculum((prevCurriculum) => {
                const copy = [...prevCurriculum];

                copy[activeWeekIndex] = {
                    ...copy[activeWeekIndex],
                    module_learning_objectives: finalUpdated,
                };

                return copy;
            });

            return finalUpdated;
        });
    };

    const handleInstructorChange = (field: string, value: any) => {
        setInstructorDetails(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleVideoUpload = (file: File | null) => {
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setInstructorDetails(prev => ({
            ...prev,
            introVideo: file,
            introVideoPreview: previewUrl
        }));
    };

    const handleImageUpload = (file: File | null) => {
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setInstructorDetails(prev => ({
            ...prev,
            profileImage: file,
            profileImagePreview: previewUrl
        }));
    };

    // updating course details
    const handleUpdateCourse = async () => {
        setUpdatingCourseDet(true);
        try {
            // ---------------
            // 1. Update Course Basic
            // ---------------
            try {
                // const payload = new URLSearchParams();
                const payload = new FormData();

                payload.append("title", mainTitle);
                payload.append("name", courseDetails.name);
                payload.append("description", courseDescription);
                payload.append("difficulty", learner);
                payload.append("target_audience", courseTargetAudi);
                payload.append("suggested_price", coursePrice);
                payload.append("duration", courseDuration);
                payload.append("price_type", priceType); /* new */

                payload.append("social_url", instructorDetails.profileUrl);
                payload.append("cta_lable", instructorDetails.ctaLabel);
                payload.append("cta_url", instructorDetails.ctaUrl);

                if (instructorDetails.introVideo) {
                    payload.append("video_file", instructorDetails.introVideo);
                }

                /* if (instructorDetails.profileImage) {
                    payload.append("profile_image", instructorDetails.profileImage);
                } */

                const res = await axios.put(`${apiUrl}/api/prompts/update_course_basic/${courseId}`,
                    payload,
                    {
                        headers: {
                            "content-type": "application/x-www-form-urlencoded"
                        }
                    });

                await uploadInstructorProfileImage();
            } catch (err: any) {
                toast.error("Failed to update course basic details");
                return;
            }

            // ------------
            // 2. Update Learning Outcomes
            // ------------
            try {
                const loPayload = new URLSearchParams();

                loPayload.append(
                    "learning_outcomes",
                    JSON.stringify(courseLearningOutcomes)
                );

                const loRes = await axios.put(
                    `${apiUrl}/api/prompts/update_learning_outcomes/${courseId}`,
                    loPayload,
                    {
                        headers: {
                            "content-type": "application/x-www-form-urlencoded"
                        }
                    }
                );
            } catch (err: any) {
                toast.error("Failed to update learning outcomes");
                return;
            }

            // -------------------------
            // 3. Update all weeks in loop
            // -------------------------
            for (const weekItem of curriculum) {
                try {
                    /* const weekPayload = new URLSearchParams();

                    weekPayload.append("title", weekItem.title);
                    weekPayload.append("content", weekItem.content);
                    weekPayload.append("chapter_image_url", weekItem.chapter_image_url || "");

                    weekPayload.append(
                        "subtopics",
                        JSON.stringify(weekItem.subtopics || [])
                    );

                    const UAWRes = await axios.put(
                        `${apiUrl}/api/prompts/update_week/${courseId}/${weekItem.week}`,
                        weekPayload,
                        {
                            headers: { "content-type": "application/x-www-form-urlencoded" }
                        }
                    ); */
                    if (weekItem.chapter_image_file) {
                        const formData = new FormData();

                        formData.append("title", weekItem.title);
                        formData.append("content", weekItem.content);
                        formData.append(
                            "subtopics",
                            JSON.stringify(weekItem.subtopics || [])
                        );
                        formData.append(
                            "learning_objectives",
                            JSON.stringify(weekItem.module_learning_objectives || [])
                        ); /* new */
                        formData.append("chapter_image", weekItem.chapter_image_file);

                        await axios.put(
                            `${apiUrl}/api/prompts/update_week/${courseId}/${weekItem.week}`,
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                },
                            }
                        );
                    } else {
                        const weekPayload = new URLSearchParams();

                        weekPayload.append("title", weekItem.title);
                        weekPayload.append("content", weekItem.content);
                        weekPayload.append(
                            "subtopics",
                            JSON.stringify(weekItem.subtopics || [])
                        );
                        weekPayload.append(
                            "learning_objectives",
                            JSON.stringify(weekItem.module_learning_objectives || [])
                        );
                        weekPayload.append(
                            "chapter_image_url",
                            weekItem.chapter_image_url || ""
                        );

                        await axios.put(
                            `${apiUrl}/api/prompts/update_week/${courseId}/${weekItem.week}`,
                            weekPayload,
                            {
                                headers: {
                                    "content-type": "application/x-www-form-urlencoded",
                                },
                            }
                        );
                    }
                } catch (err: any) {
                    toast.error(`Failed to update week ${weekItem.week}`);
                    return;
                }
            }

            // -----------------
            // 4. update image
            // -----------------
            try {
                if (selectedUnsplashImage) {

                    const imageResp = await fetch(selectedUnsplashImage);
                    const blob = await imageResp.blob();

                    const file = new File([blob], "course.jpg", { type: blob.type });

                    const formData = new FormData();
                    formData.append("course_image", file);

                    await axios.post(
                        `${apiUrl}/api/prompts/upload_course_image`,
                        formData,
                        {
                            params: {
                                course_id: courseId
                            }
                        }
                    );
                }
            } catch (err) {
                toast.error("Failed to upload course image");
                return;
            }
            toast.success("Course updated successfully");
            getCourseDetail();
        } catch (error: any) {
            console.log('Error updating course details=>', error);
        } finally {
            setUpdatingCourseDet(false);
        }
    };

    const openUnsplashPicker = async (query: string) => {
        try {
            setShowUnsplash(true);

            const res = await axios.get(
                "https://api.unsplash.com/search/photos",
                {
                    params: {
                        query,
                        per_page: 20
                    },
                    headers: {
                        Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
                    }
                }
            );

            setUnsplashImages(res.data.results);

        } catch (err) {
            toast.error("Failed to load Unsplash images");
        }
    };

    /* const handleSelectUnsplashImage = (img: any) => {

        // show selected image in main preview
        setCourseImage(img.urls.regular);

        // store chosen path for API usage later
        setSelectedUnsplashImage(img.urls.raw);

        setShowUnsplash(false);

    }; */
    /* const handleSelectUnsplashImage = (img: any) => {

        // preview for current UI
        setCourseImage(img.urls.regular);

        // update only active week
        setCurriculum((prev) => {
            const copy = [...prev];

            copy[activeWeekIndex] = {
                ...copy[activeWeekIndex],

                // overwrite only this week's image
                chapter_image_url: img.urls.raw,

                // optional preview
                chapter_image_preview: img.urls.regular,
            };

            return copy;
        });

        setShowUnsplash(false);
    }; */

    const handleSelectUnsplashImage = async (imageUrl: any, imageid: any) => {
        setCourseImage(imageUrl);

        const response = await fetch(imageUrl);
        const blob = await response.blob();
        const file = new File([blob], "unsplash_image.jpg", { type: blob.type });

        setCurriculum((prev) => {
            const copy = [...prev];

            copy[activeWeekIndex] = {
                ...copy[activeWeekIndex],
                chapter_image_preview: imageUrl,
                chapter_image_url: imageUrl,
                chapter_image_file: file,
            };

            return copy;
        });

        setShowUnsplash(false);
    };

    const fetchData = async () => {
        try {

            const response = await getUserDetailsMutation({ email: useremail, filter: '', start_date: '', end_date: '' });

            if ('data' in response) {
                const details = response.data.data;
                setUserDetails(details);
                console.log('userdetails from edit course=>', details);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleImageClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleSearch = async () => {
        setUnsplashSearch(true);
        if (!query) {
            toast.error('Please enter any value to search');
        } else {
            try {
                // const response = await axios.get(`https://api.unsplash.com/search/photos`, {
                const response = await axios.get(
                    "https://api.unsplash.com/search/photos",
                    {
                        params: {
                            query,
                            per_page: 20
                        },
                        headers: {
                            Authorization: `Client-ID ${process.env.REACT_APP_UNSPLASH_ACCESS_KEY}`
                        }
                    }
                );
                setImages(response.data.results);
            } catch (error) {
                console.error("Error fetching images from Unsplash", error);
            }
        }
    };

    const horizontalImages = images.filter(image => image.width > image.height);

    const modifyImageUrl = (url: any) => {
        let modifiedUrl = new URL(url);

        modifiedUrl.searchParams.set('fit', 'none');

        modifiedUrl.searchParams.set('w', '1152');

        modifiedUrl.searchParams.set('h', '500');

        return modifiedUrl.toString();
    };

    const handleUnsplashselectionChange = () => {
        if (!courseImage) {
            toast.error('Please select any image!');
        } else {
            setOpenUnsplash(false);
            setChoosingImageModal(false);
        }
    };

    const getPartnerDetails = async () => {
        try {

            const response = await axios.get(
                `${apiUrl}/api/users/partners/details`,
                {
                    params: {
                        partner_name: (localStorage.getItem("partner_name") ||
                            userDetails?.partner),
                    },
                }
            );

            if (
                response.data?.status === "success" &&
                response.data?.data
            ) {
                const data = response.data.data;
                setGBAUserLogo(data.logo_url);
            }
        } catch (err) {
            console.log("Partner details not found", err);
        }
    };

    useEffect(() => {
        if ((localStorage.getItem("partner_name") /* === "GPA" */ || userDetails?.partner /* === "GPA" */)) {
            getPartnerDetails();
        }
    }, []);

    useEffect(() => {
        const handler = (e: any) => {
            setGBAUserLogo(e.detail.logo);
        };

        window.addEventListener("partner-logo-updated", handler);

        return () => {
            window.removeEventListener("partner-logo-updated", handler);
        };
    }, []);

    return (
        <>
            {loadingCourse && (
                <Box
                    sx={{
                        position: 'fixed',
                        inset: 0,
                        zIndex: 2000,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 2,
                        background: '#020617',
                    }}
                >
                    <CircularProgress size={48} sx={{ color: '#4BA5EB' }} />
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 14 }}>
                        Loading course content...
                    </Typography>
                </Box>
            )}
            {/* <Header /> */}
            <div style={{ overflowX: 'hidden' }}>
                <div className="row">
                    {/* header */}
                    <div className="row" style={{ marginTop: '1%' }}>
                        {/* <div className="col-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                            <img src={oceshaLogo} alt="" style={{ width: '30%' }} />
                            {(localStorage.getItem('partner_name') === 'GPA' || userDetails?.partner === 'GPA') && (<img src={GBALogo} alt="" style={{ width: '30%' }} />)}
                            
                        </div> */}
                        <div
                            className="col-3"
                            style={{
                                display: "flex",
                                justifyContent: (oceshaLogo && GBAUserLogo) ? "center" : "",
                                alignItems: "center",
                                gap: "12px",
                            }}
                        >
                            <img
                                src={oceshaLogo}
                                alt="Ocesha Logo"
                                style={{
                                    width: "60px",
                                    height: "auto",
                                }}
                            />

                            {((localStorage.getItem("partner_name") /* === "GPA" */ ||
                                userDetails?.partner /* === "GPA" */) && GBAUserLogo) && (
                                    <img
                                        src={GBAUserLogo}
                                        alt="GBA Logo"
                                        style={{
                                            width: "200px",
                                            height: "100px",
                                            objectFit: "contain",
                                        }}
                                    />
                                )}
                        </div>
                        {/* <Tooltip title="Click here for help video">
                                <img src={youtubeIco1} style={{ cursor: 'pointer', height: '40px', marginTop: '-9px', marginLeft: '-9px' }}
                                    onClick={() => {
                                        setHelperVideoSrc("/images/Overview.mp4");
                                        setHelperPopup(true);
                                    }} />
                            </Tooltip> */}
                        <div className="col-9" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1px' }}>
                            <Ocesha_header handleItemClick={handleItemClick} />
                        </div>
                    </div>
                    <Divider sx={{ mt: 2 }} />
                    {/* <hr /> */}
                    {/* end header */}
                    <div className="overlay-container">
                        <Box
                            sx={{
                                minHeight: "100vh",
                                p: { xs: 2, md: 4 },
                                // background: '#fff'
                                /* background:
                                  "radial-gradient(120% 120% at 50% 0%, rgba(139,92,246,0.12), #020617 60%)", */
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                }}
                            >
                                {/* Left */}
                                <Typography sx={{ color: /* "#000" */"#fff", fontWeight: 600, fontSize: '26px' }}>
                                    Edit Course
                                </Typography>

                                {/* Right */}
                                <Stack direction="row" spacing={2} mb={2}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            background: "#fff",
                                            color: "#000",
                                            display: 'flex',
                                            gap: 1,
                                            alignItems: 'center',
                                            "&:hover": { background: '#fff', color: '#000' }
                                        }}
                                        onClick={() => navigate('/codegenie/generated-blogs')

                                        }
                                    >
                                        <WestIcon />Back to courses list
                                    </Button>

                                    <Button
                                        variant="contained"
                                        sx={{
                                            textTransform: "none",
                                            background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                            borderRadius: "50px",
                                            color: '#fff'
                                        }}
                                        onClick={handleUpdateCourse}
                                    >
                                        {updatingCourseDet ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : "Save"}
                                    </Button>
                                </Stack>
                            </Box>
                            <Divider />

                            <Box sx={{ background: '#fff', p: 1, pr: 2, pl: 2, pb: 2, borderRadius: '10px' }}>
                                <Paper
                                    sx={{
                                        p: 2,
                                        mb: 2,
                                        borderRadius: 2,
                                        background: "transparent",
                                        border: "1px solid #1f2933",
                                        mt: 2,
                                    }}
                                >
                                    {/* <Typography color="#fff" fontWeight={600}>
                                    Speak & Play: Transforming Speech Therapy Access
                                </Typography> */}
                                    <TextField
                                        value={mainTitle?.replace(/\bweeks?\b/i, "Module")}
                                        onChange={(e) => setMainTitle(e.target.value)}
                                        variant="standard"
                                        fullWidth
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                        sx={{
                                            mb: 1,

                                            "& .MuiInputBase-input": {
                                                // color: "#fff !important",
                                                color: "#000 !important",
                                                fontWeight: 600,
                                                fontSize: "22px",
                                                padding: 0,
                                            },
                                        }}
                                    />
                                </Paper>

                                <Grid container spacing={3} alignItems="stretch">
                                    {/* LEFT PANEL */}
                                    <Grid item xs={12} md={8}>
                                        {/* Module Title - Outside Paper */}
                                        <Box
                                            sx={{
                                                mb: 1.5,
                                                width: "100%",
                                            }}
                                        >
                                            <Paper
                                                sx={{
                                                    width: "100%",
                                                    p: 2.5,
                                                    borderRadius: 2,
                                                    background: "transparent",
                                                    border: "1px solid #1f2933",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        gap: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        component="span"
                                                        sx={{
                                                            fontSize: "16px",
                                                            fontWeight: 600,
                                                            color: "#000",
                                                            whiteSpace: "nowrap",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        Module {activeWeekIndex + 1}:
                                                    </Typography>

                                                    <TextField
                                                        fullWidth
                                                        variant="standard"
                                                        value={title1?.replace(/\bweeks?\b/i, "Module")}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            setTitle1(value);

                                                            setCurriculum((prev) => {
                                                                const copy = [...prev];

                                                                copy[activeWeekIndex] = {
                                                                    ...copy[activeWeekIndex],
                                                                    title: value,
                                                                };

                                                                return copy;
                                                            });
                                                        }}
                                                        InputProps={{
                                                            disableUnderline: true,
                                                        }}
                                                        sx={{
                                                            flex: 1,
                                                            minWidth: 0,
                                                            input: {
                                                                fontSize: "16px",
                                                                fontWeight: 600,
                                                                color: "#000 !important",
                                                                padding: 0,
                                                            },
                                                        }}
                                                    />
                                                </Box>
                                            </Paper>
                                        </Box>

                                        <Box
                                            sx={{
                                                mb: 1.5,
                                                width: "100%",
                                            }}
                                        >
                                            <Paper
                                                sx={{
                                                    width: "100%",
                                                    p: 2.5,
                                                    borderRadius: 2,
                                                    background: "transparent",
                                                    border: "1px solid #1f2933",
                                                    boxSizing: "border-box",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 1,
                                                        mb: 1.5,
                                                    }}
                                                >
                                                    <CheckCircleIcon
                                                        sx={{ color: "#16a34a", fontSize: 20 }}
                                                    />
                                                    <Typography
                                                        sx={{
                                                            fontSize: "16px",
                                                            fontWeight: 600,
                                                            color: "#000",
                                                        }}
                                                    >
                                                        Module Learning Objectives
                                                    </Typography>
                                                </Box>

                                                <Stack spacing={0.5}>
                                                    {moduleLearningObjectives.map((objective, index) => (
                                                        <Box
                                                            key={index}
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "flex-start",
                                                                gap: 1,
                                                                "&:hover .objective-delete-btn": {
                                                                    opacity: 1,
                                                                },
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color: "#000",
                                                                    fontSize: "14px",
                                                                    lineHeight: "2.1",
                                                                }}
                                                            >
                                                                •
                                                            </Typography>

                                                            <TextField
                                                                fullWidth
                                                                variant="standard"
                                                                placeholder="Enter a learning objective"
                                                                value={objective}
                                                                onChange={(e) =>
                                                                    handleObjectiveChange(index, e.target.value)
                                                                }
                                                                InputProps={{
                                                                    disableUnderline: true,
                                                                }}
                                                                sx={{
                                                                    flex: 1,
                                                                    minWidth: 0,
                                                                    "& .MuiInputBase-input": {
                                                                        color: "#000 !important",
                                                                        fontSize: "14px",
                                                                        padding: "6px 0",
                                                                    },
                                                                }}
                                                            />

                                                            <IconButton
                                                                className="objective-delete-btn"
                                                                size="small"
                                                                onClick={() => handleRemoveObjective(index)}
                                                                sx={{
                                                                    color: "#9ca3af",
                                                                    opacity: isMobile ? 1 : 0,
                                                                    transition: "opacity 0.15s ease",
                                                                }}
                                                            >
                                                                <DeleteOutlineIcon fontSize="small" />
                                                            </IconButton>
                                                        </Box>
                                                    ))}
                                                </Stack>

                                                <Button
                                                    onClick={handleAddObjective}
                                                    startIcon={<AddIcon fontSize="small" />}
                                                    sx={{
                                                        mt: 1,
                                                        textTransform: "none",
                                                        color: "#2563eb",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        p: 0,
                                                        minWidth: "auto",
                                                        "&:hover": {
                                                            background: "transparent",
                                                            textDecoration: "underline",
                                                        },
                                                    }}
                                                >
                                                    Add objective
                                                </Button>
                                            </Paper>
                                        </Box>

                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #1f2933",
                                            }}
                                        >

                                            {/* Title 1 */}
                                            {/* <TextField
                                                fullWidth
                                                variant="standard"
                                                value={title1}
                                                // onChange={(e) => setTitle1(e.target.value)}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setTitle1(value);

                                                    setCurriculum((prev) => {
                                                        const copy = [...prev];
                                                        copy[activeWeekIndex] = {
                                                            ...copy[activeWeekIndex],
                                                            title: value,
                                                        };
                                                        return copy;
                                                    });
                                                }}
                                                InputProps={{ disableUnderline: true }}
                                                sx={{
                                                    mb: 0.5,
                                                    input: {
                                                        fontSize: "16px",
                                                        fontWeight: 600,
                                                        // color: "#fff !important",
                                                        color: "#000 !important",
                                                    },
                                                }}
                                            /> */}

                                            {/* Description 1 */}
                                            {/* <TextField
                                            fullWidth
                                            multiline
                                            minRows={15}
                                            maxRows={15}
                                            variant="standard"
                                            value={desc1}
                                            // onChange={(e) => setDesc1(e.target.value)}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setDesc1(value);

                                                setCurriculum((prev) => {
                                                    const copy = [...prev];
                                                    copy[activeWeekIndex] = {
                                                        ...copy[activeWeekIndex],
                                                        content: value,
                                                    };
                                                    return copy;
                                                });
                                            }}
                                            InputProps={{ disableUnderline: true }}
                                            sx={{
                                                mb: 2,
                                                textarea: {
                                                    fontSize: "16px",
                                                    color: "#fff !important",
                                                    lineHeight: 1.7,
                                                    maxHeight: '400px',
                                                    msOverflowY: 'auto'
                                                },
                                            }}
                                        /> */}
                                            {/* <ReactQuill
                                                value={desc1}
                                                onChange={(value) => {
                                                    setDesc1(value);

                                                    setCurriculum((prev) => {
                                                        const copy = [...prev];
                                                        copy[activeWeekIndex] = {
                                                            ...copy[activeWeekIndex],
                                                            content: value,
                                                        };
                                                        return copy;
                                                    });
                                                }}
                                                theme="bubble"
                                                modules={{
                                                    toolbar: [
                                                        ["bold", "italic", "underline"],
                                                        [{ list: "ordered" }, { list: "bullet" }],
                                                        ["link"],
                                                    ],
                                                }}
                                                className="curriculum-quill"
                                                readOnly={false}
                                                style={{ color: '#000 !important' }}
                                            /> */}
                                            <ReactQuill
                                                value={desc1?.replace(/\bweeks?\b/i, "Module")}
                                                onChange={(value) => {
                                                    setDesc1(value);

                                                    setCurriculum((prev) => {
                                                        const copy = [...prev];

                                                        copy[activeWeekIndex] = {
                                                            ...copy[activeWeekIndex],
                                                            content: value,
                                                        };

                                                        return copy;
                                                    });
                                                }}
                                                theme="bubble"
                                                modules={{
                                                    toolbar: [
                                                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                        [{ list: "ordered" }, { list: "bullet" }],
                                                        ["bold", "italic", "underline"],
                                                        ["link"],
                                                        [
                                                            { align: "" },
                                                            { align: "center" },
                                                            { align: "right" },
                                                            { align: "justify" },
                                                        ],
                                                    ],
                                                }}
                                                className="curriculum-quill"
                                                readOnly={false}
                                            />
                                            <Divider sx={{ mt: 2, mb: 2 }} />
                                            {/* Image */}
                                            {/* <Box
                                                sx={{
                                                    position: "relative",
                                                    borderRadius: 2,
                                                    overflow: "hidden",
                                                    mb: 2,
                                                }}
                                            >
                                                <Box
                                                    key={`${activeWeekIndex}-${courseImage}`}
                                                    component="img"
                                                    src={
                                                        !courseImage
                                                            ? ""
                                                            : /^(https?:|blob:)/i.test(courseImage)
                                                                ? courseImage
                                                                : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${courseImage.startsWith("/") ? "" : "/"
                                                                }${courseImage}`
                                                    }
                                                    sx={{
                                                        width: "100%",
                                                        height: { xs: 200, md: 280 },
                                                        objectFit: "contain",
                                                    }}
                                                />

                                                <Button
                                                    size="small"
                                                    onClick={() => setChoosingImageModal(true)}
                                                    sx={{
                                                        position: "absolute",
                                                        top: 10,
                                                        right: 10,
                                                        textTransform: "none",
                                                        background: "rgba(0,0,0,0.55)",
                                                        color: "#fff",
                                                        border: "1px solid #374151",
                                                        "&:hover": { background: "rgba(0,0,0,0.7)" },
                                                    }}
                                                >
                                                    Edit image
                                                </Button>

                                                <input
                                                    ref={fileRef}
                                                    hidden
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                />
                                            </Box> */}
                                            {/* Image */}
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    borderRadius: 2,
                                                    overflow: "hidden",
                                                    mb: 2,

                                                    // Scroll only when image is taller than this area
                                                    maxHeight: { xs: 300, md: 300/* 450 */ },
                                                    overflowY: "auto",

                                                    // Keep horizontal overflow hidden
                                                    overflowX: "hidden",

                                                    // Optional scrollbar styling
                                                    "&::-webkit-scrollbar": {
                                                        width: "6px",
                                                    },
                                                    "&::-webkit-scrollbar-thumb": {
                                                        background: "#999",
                                                        borderRadius: "10px",
                                                    },
                                                    "&::-webkit-scrollbar-track": {
                                                        background: "#f1f1f1",
                                                    },
                                                }}
                                            >
                                                <Box
                                                    key={`${activeWeekIndex}-${courseImage}`}
                                                    component="img"
                                                    src={
                                                        !courseImage
                                                            ? ""
                                                            : /^(https?:|blob:)/i.test(courseImage)
                                                                ? courseImage
                                                                : `${process.env.REACT_APP_RETURN_DOMAIN_NAME}${courseImage.startsWith("/") ? "" : "/"
                                                                }${courseImage}`
                                                    }
                                                    sx={{
                                                        width: "100%",
                                                        height: "auto",
                                                        display: "block",
                                                        objectFit: "contain",
                                                    }}
                                                />

                                                <Button
                                                    size="small"
                                                    onClick={() => setChoosingImageModal(true)}
                                                    sx={{
                                                        position: "absolute",
                                                        top: 10,
                                                        right: 10,
                                                        textTransform: "none",
                                                        background: "rgba(0,0,0,0.55)",
                                                        color: "#fff",
                                                        border: "1px solid #374151",
                                                        "&:hover": {
                                                            background: "rgba(0,0,0,0.7)",
                                                        },
                                                    }}
                                                >
                                                    Edit image
                                                </Button>

                                                <input
                                                    ref={fileRef}
                                                    hidden
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                />
                                            </Box>

                                            <Divider sx={{ my: 2 }} />

                                            <Stack
                                                direction="row"
                                                spacing={1}
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Button
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        borderColor: "#374151",
                                                        // color: "#cbd5f5",
                                                        color: '#000'
                                                    }}
                                                    disabled={activeWeekIndex === 0}
                                                    onClick={() =>
                                                        setActiveWeekIndex((prev) => Math.max(prev - 1, 0))
                                                    }
                                                >
                                                    <KeyboardArrowLeftIcon /> Previous Module
                                                </Button>

                                                <Typography
                                                    sx={{ fontSize: 12, color: '#000'/* "#9ca3af" */ }}
                                                >
                                                    {/* Week {curriculum[activeWeekIndex]?.week} */}
                                                    Module {activeWeekIndex + 1} of {curriculum.length}
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    sx={{
                                                        textTransform: "none",
                                                        background: "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                                        color: '#fff'
                                                    }}
                                                    disabled={activeWeekIndex === curriculum.length - 1}
                                                    onClick={() =>
                                                        setActiveWeekIndex((prev) =>
                                                            Math.min(prev + 1, curriculum.length - 1)
                                                        )
                                                    }
                                                >
                                                    Next Module <KeyboardArrowRightIcon />
                                                </Button>
                                            </Stack>
                                        </Paper>
                                    </Grid>

                                    {/* RIGHT PANEL */}
                                    <Grid item xs={12} md={4} sx={{ display: "flex" }}>
                                        <Paper
                                            sx={{
                                                p: 2.5,
                                                borderRadius: 2,
                                                background: "transparent",
                                                border: "1px solid #767676",

                                                width: "100%",
                                                height: "100%",
                                                boxSizing: "border-box",
                                                display: "flex",
                                                flexDirection: "column",
                                            }}
                                        >
                                            <Stack sx={{ flex: 1 }}>
                                                <Typography fontSize="16px" color='#000'/* "#9ca3af" */ mb={2}>
                                                    Section content
                                                </Typography>

                                                <TextField
                                                    label="Title"
                                                    // value="Design Blog"
                                                    value={title1?.replace(/\bweeks?\b/i, "Module")}
                                                    // onChange={(e) => setTitle(e.target.value)}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setTitle1(value);

                                                        setCurriculum((prev) => {
                                                            const copy = [...prev];
                                                            copy[activeWeekIndex] = {
                                                                ...copy[activeWeekIndex],
                                                                title: value,
                                                            };
                                                            return copy;
                                                        });
                                                    }}
                                                    size="small"
                                                    fullWidth
                                                    // sx={{ mb: 2 }}
                                                    sx={{
                                                        mb: 2,

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },

                                                        // Input text
                                                        "& .MuiInputBase-input": {
                                                            color: "#000",
                                                        },

                                                        // Border
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                        },
                                                    }}
                                                />

                                                <Divider sx={{ borderColor: '#fff !important', mb: 2 }} />

                                                {/* <Typography fontSize="16px" color="#9ca3af">
                                                Section content
                                            </Typography> */}

                                                <Typography fontSize="14px" color='#000'/* "#9ca3af" */ mb={2}>
                                                    Course Details{/*  - <a href="">Current</a> */}
                                                </Typography>

                                                <TextField
                                                    label="Course Description"
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    minRows={4}
                                                    value={courseDescription}
                                                    onChange={(e: any) => setCourseDescription(e.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                        },
                                                    }}
                                                />

                                                <TextField
                                                    label="Target Audience"
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    minRows={2}
                                                    value={courseTargetAudi}
                                                    onChange={(e: any) => setCourseTargetAudi(e.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                        },
                                                    }}
                                                />

                                                <Box sx={{ display: 'flex', gap: 1 }}>
                                                    <TextField
                                                        label="Learner Level"
                                                        size="small"
                                                        fullWidth
                                                        value={learner}
                                                        onChange={(e: any) => setLearner(e.target.value)}
                                                        /* sx={{
                                                            "& .MuiInputBase-input": {
                                                                cursor: "pointer",
                                                            },
                                                            mb: 2
                                                        }} */
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{
                                                            mb: 2,

                                                            "& .MuiInputBase-input": {
                                                                // cursor: "pointer",
                                                                color: "#000",
                                                            },

                                                            // Label
                                                            "& .MuiInputLabel-root": {
                                                                color: "#000",
                                                            },
                                                            "& .MuiInputLabel-root.Mui-focused": {
                                                                color: "#000",
                                                            },

                                                            // Border
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                    <TextField
                                                        label="Duration"
                                                        size="small"
                                                        fullWidth
                                                        value={courseDuration}
                                                        onChange={(e: any) => setCourseDuration(e.target.value)}
                                                        /* sx={{
                                                            "& .MuiInputBase-input": {
                                                                cursor: "pointer",
                                                            },
                                                            mb: 2
                                                        }} */
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{
                                                            mb: 2,

                                                            "& .MuiInputBase-input": {
                                                                // cursor: "pointer",
                                                                color: "#000",
                                                            },

                                                            // Label
                                                            "& .MuiInputLabel-root": {
                                                                color: "#000",
                                                            },
                                                            "& .MuiInputLabel-root.Mui-focused": {
                                                                color: "#000",
                                                            },

                                                            // Border
                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                            },
                                                        }}
                                                    />
                                                </Box>

                                                <TextField
                                                    label="Expected Outcome"
                                                    size="small"
                                                    fullWidth
                                                    multiline
                                                    minRows={4}
                                                    value={courseLearningOutcomes}
                                                    onChange={(e: any) => setCourseLearningOutcomes(e.target.value)}
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },

                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                        },
                                                    }}
                                                />

                                                {/* Pricing */}
                                                <FormControl sx={{ mb: 2 }}>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            // fontWeight: 600,
                                                            color: "#000",
                                                            mb: 0.5,
                                                        }}
                                                    >
                                                        Pricing
                                                    </Typography>

                                                    <RadioGroup
                                                        row
                                                        value={priceType}
                                                        onChange={(e) => {
                                                            setPriceType(e.target.value);
                                                        }}
                                                    >
                                                        <FormControlLabel
                                                            value="free"
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        color: "#000",
                                                                        "&.Mui-checked": {
                                                                            color: "#1976d2",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    Free Course
                                                                </Typography>
                                                            }
                                                        />

                                                        <FormControlLabel
                                                            value="paid"
                                                            control={
                                                                <Radio
                                                                    size="small"
                                                                    sx={{
                                                                        color: "#000",
                                                                        "&.Mui-checked": {
                                                                            color: "#1976d2",
                                                                        },
                                                                    }}
                                                                />
                                                            }
                                                            label={
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "13px",
                                                                        color: "#000",
                                                                    }}
                                                                >
                                                                    Paid Course
                                                                </Typography>
                                                            }
                                                        />
                                                    </RadioGroup>
                                                </FormControl>

                                                {/* Suggested Price + Currency */}
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        gap: 1,
                                                        mb: 2,
                                                        width: "100%",
                                                    }}
                                                >
                                                    <TextField
                                                        label="Price"
                                                        size="small"
                                                        fullWidth
                                                        type="number"
                                                        value={coursePrice}
                                                        disabled={priceType === "free"}
                                                        onChange={(e) => setCoursePrice(e.target.value)}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        sx={{
                                                            "& .MuiInputBase-input": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiInputLabel-root": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiInputLabel-root.Mui-focused": {
                                                                color: "#000",
                                                            },

                                                            "& .MuiOutlinedInput-root": {
                                                                "& fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&:hover fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                                "&.Mui-focused fieldset": {
                                                                    borderColor: "#000",
                                                                },
                                                            },

                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                WebkitTextFillColor: "#777",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                                                                borderColor: "#aaa",
                                                            },
                                                        }}
                                                    />

                                                    <TextField
                                                        value="USD"
                                                        size="small"
                                                        disabled
                                                        sx={{
                                                            width: "90px",

                                                            "& .MuiInputBase-input": {
                                                                color: "#000",
                                                                fontWeight: 500,
                                                            },

                                                            "& .MuiInputBase-input.Mui-disabled": {
                                                                WebkitTextFillColor: "#000",
                                                            },

                                                            "& .MuiOutlinedInput-root.Mui-disabled fieldset": {
                                                                borderColor: "#000",
                                                            },
                                                        }}
                                                    />
                                                </Box>

                                                {/* <Box> */}
                                                {/* <Typography fontSize="12px" color="#9ca3af" mb={0.5}>
                                                    Progress
                                                </Typography> */}
                                                {/* <TextField
                                                    value={`Progress ${courseDetails?.content_generation_progress?.generated}`}
                                                    size="small"
                                                    fullWidth
                                                    InputProps={{
                                                        readOnly: true
                                                    }}
                                                    sx={{
                                                        pointerEvents: "none"
                                                    }}
                                                /> */}

                                                {/* <LinearProgress
                                                    variant="determinate"
                                                    value={50}
                                                    sx={{
                                                        height: 6,
                                                        borderRadius: 4,
                                                        backgroundColor: "#374151",
                                                        "& .MuiLinearProgress-bar": {
                                                            backgroundColor: "#2563eb",
                                                        },
                                                    }}
                                                /> */}
                                                {/* </Box> */}

                                                <Typography fontSize="14px" color='#000'/* "#9ca3af" */>
                                                    Instructor Profile Image
                                                </Typography>
                                                {/* <Typography fontSize="16px" sx={{
                                                    color: "#60a5fa",
                                                    cursor: "pointer",
                                                    textDecoration: "underline",
                                                    display: "inline-block",
                                                    mb: 3
                                                }} onClick={() => {
                                                    localStorage.setItem('activeItem', 'settings');
                                                    navigate('/codegenie/generated-blogs');
                                                }}>
                                                    Change profile Image here
                                                </Typography> */}
                                                <input
                                                    id="instructor-profile-image-input"
                                                    type="file"
                                                    accept="image/*"
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleImageUpload(e.target.files?.[0] || null)}
                                                />

                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, mt: 1 }}>
                                                    {(instructorDetails.profileImagePreview || instructorDetails.existingImageUrl) && (
                                                        <img
                                                            src={instructorDetails.profileImagePreview || instructorDetails.existingImageUrl}
                                                            alt="Instructor"
                                                            style={{
                                                                width: '56px',
                                                                height: '56px',
                                                                borderRadius: '50%',
                                                                objectFit: 'cover',
                                                                border: '2px solid #ccc'
                                                            }}
                                                        />
                                                    )}
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => document.getElementById('instructor-profile-image-input')?.click()}
                                                        sx={{
                                                            textTransform: 'none',
                                                            borderColor: '#000',
                                                            color: '#000',
                                                            '&:hover': { borderColor: '#3b82f6', color: '#3b82f6' }
                                                        }}
                                                    >
                                                        {(instructorDetails.profileImagePreview || instructorDetails.existingImageUrl) ? 'Change Photo' : 'Upload Photo'}
                                                    </Button>
                                                </Box>
                                                {/* <Button
                                                component="label"
                                                size="small"
                                                sx={{
                                                    textTransform: "none",
                                                    border: "1px solid #374151",
                                                    color: "#cbd5f5",
                                                }}
                                            >
                                                Choose file
                                                <input
                                                    // hidden
                                                    type="file"
                                                    accept="image/*"
                                                    onChange={(e) =>
                                                        handleImageUpload(e.target.files?.[0] || null)
                                                    }
                                                />
                                            </Button> */}
                                                {/* {instructorDetails.profileImagePreview && (
                                                <Box mt={2}>
                                                    <img
                                                        src={instructorDetails.profileImagePreview}
                                                        alt="Instructor"
                                                        style={{
                                                            width: "120px",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "50%", // circle DP look
                                                            border: "2px solid #374151"
                                                        }}
                                                    />
                                                </Box>
                                            )} */}

                                                <TextField
                                                    label="Authority Page URL"
                                                    size="small"
                                                    fullWidth
                                                    // value={instructorDetails.profileUrl}
                                                    /* onChange={(e) =>
                                                        handleInstructorChange("profileUrl", e.target.value)
                                                    } */
                                                    value={`${window.location.origin}/profile/${userDetails?.profile_id}`}
                                                    InputProps={{
                                                        readOnly: true,
                                                    }}
                                                    onClick={() => {
                                                        window.open(
                                                            `${window.location.origin}/profile/${encodeURIComponent(
                                                                courseDetails?.user_id || ""
                                                            )}`,
                                                            "_blank"
                                                        );
                                                    }}
                                                    /* sx={{
                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                        },
                                                        mb: 2
                                                    }} */
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                            color: "#000",
                                                        },

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000"
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                        },
                                                        // Border
                                                        // "& .MuiOutlinedInput-root": {
                                                        //     "& fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        //     "&:hover fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        //     "&.Mui-focused fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        // },
                                                    }}
                                                />

                                                <TextField
                                                    label="View Course"
                                                    size="small"
                                                    fullWidth
                                                    // value={instructorDetails.profileUrl}
                                                    /* onChange={(e) =>
                                                        handleInstructorChange("profileUrl", e.target.value)
                                                    } */
                                                    value={instructorDetails.profileUrl1}
                                                    inputProps={{
                                                        readOnly: true,
                                                    }}
                                                    /* sx={{
                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                        },
                                                        mb: 2
                                                    }} */
                                                    sx={{
                                                        mb: 2,

                                                        "& .MuiInputBase-input": {
                                                            cursor: "pointer",
                                                            color: "#000",
                                                        },

                                                        // Label
                                                        "& .MuiInputLabel-root": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiInputLabel-root.Mui-focused": {
                                                            color: "#000",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                            "&:hover fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: "#000 !important",
                                                            },
                                                        },
                                                        // Border
                                                        // "& .MuiOutlinedInput-root": {
                                                        //     "& fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        //     "&:hover fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        //     "&.Mui-focused fieldset": {
                                                        //         borderColor: "#000",
                                                        //     },
                                                        // },
                                                    }}
                                                    onClick={() => {
                                                        window.open(
                                                            `${instructorDetails.profileUrl1}`,
                                                            "_blank"
                                                        );
                                                    }}
                                                />

                                                {/* <TextField
                                                label="CTA Label"
                                                size="small"
                                                fullWidth
                                                value={instructorDetails.ctaLabel}
                                                onChange={(e) =>
                                                    handleInstructorChange("ctaLabel", e.target.value)
                                                }
                                            />

                                            <TextField
                                                label="CTA URL"
                                                size="small"
                                                fullWidth
                                                value={instructorDetails.ctaUrl}
                                                onChange={(e) =>
                                                    handleInstructorChange("ctaUrl", e.target.value)
                                                }
                                            /> */}

                                                <Button
                                                    variant="contained"
                                                    fullWidth
                                                    sx={{
                                                        mt: 1,
                                                        textTransform: "none",
                                                        background:
                                                            "linear-gradient(90deg,#2563eb,#1d9bf0)",
                                                        color: '#fff'
                                                    }}
                                                    onClick={() => videoInputRef.current?.click()}
                                                >
                                                    Add Introduction Video
                                                    <input
                                                        hidden
                                                        type="file"
                                                        accept="video/*"
                                                        onChange={(e) =>
                                                            handleVideoUpload(e.target.files?.[0] || null)
                                                        }
                                                        ref={videoInputRef}
                                                    />
                                                </Button>
                                                {videoSrc/* instructorDetails.introVideoPreview */ && (
                                                    <Box mt={2}>
                                                        <video
                                                            width="100%"
                                                            controls
                                                            style={{ borderRadius: "8px" }}
                                                            key={videoSrc}
                                                        >
                                                            <source
                                                                src={videoSrc
                                                                    /*  instructorDetails.introVideo
                                                                         ? instructorDetails.introVideoPreview
                                                                         : process.env.REACT_APP_SERVER_ENDPOINT + instructorDetails.introVideoPreview */
                                                                }
                                                                type="video/mp4"
                                                            />
                                                        </video>
                                                    </Box>
                                                )}
                                            </Stack>
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>

                        {/* Modals */}

                        {/* unsplash */}
                        {/* <Modal
                            open={showUnsplash}
                            onClose={() => setShowUnsplash(false)}
                        >
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    width: { xs: "95%", md: 800 },
                                    bgcolor: "#0b1220",
                                    borderRadius: 5,
                                    p: 5,
                                    maxHeight: "80vh",
                                    overflowY: "auto",
                                    outline: "none"
                                }}
                            >
                                <Typography sx={{ mb: 1.5, color: "#fff", fontWeight: 600 }}>
                                    Choose an image from Unsplash
                                </Typography>

                                <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Search images (eg: education, coding, classroom...)"
                                        value={unsplashSearch}
                                        onChange={(e) => setUnsplashSearch(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                openUnsplashPicker(unsplashSearch);
                                            }
                                        }}
                                        sx={{
                                            input: { color: "#fff" }
                                        }}
                                    />

                                    <Button
                                        variant="contained"
                                        onClick={() => openUnsplashPicker(unsplashSearch)}
                                        sx={{ whiteSpace: "nowrap" }}
                                    >
                                        Search
                                    </Button>
                                </Box>

                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(4, 1fr)",
                                        gap: 1
                                    }}
                                >
                                    {unsplashImages.map((img) => (
                                        <Box
                                            key={img.id}
                                            component="img"
                                            src={img.urls.small}
                                            onClick={() => handleSelectUnsplashImage(img)}
                                            sx={{
                                                width: "100%",
                                                height: 110,
                                                objectFit: "cover",
                                                cursor: "pointer",
                                                borderRadius: 1,
                                                border:
                                                    selectedUnsplashImage === img.urls.raw
                                                        ? "2px solid #3b82f6"
                                                        : "1px solid #374151"
                                            }}
                                        />
                                    ))}
                                </Box>
                            </Box>
                        </Modal> */}

                        {/* unsplash and local image selection */}
                        <Modal
                            open={choosingImageModal}
                            onClose={() => setChoosingImageModal(false)}
                            disableEscapeKeyDown
                            aria-labelledby="child-modal-title"
                            aria-describedby="child-modal-description"
                        >
                            <Box
                                sx={{
                                    position: "absolute" as "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    transform: "translate(-50%, -50%)",
                                    width: isMobile ? "95%" : "40%",
                                    bgcolor: "#161b22",
                                    // border: "2px solid #000",
                                    // boxShadow: 24,
                                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)',
                                    pt: 2,
                                    px: 4,
                                    pb: 3,
                                    borderRadius: '15px',
                                    padding: '3%'
                                }}
                            >
                                <IconButton
                                    onClick={() => setChoosingImageModal(false)}
                                    sx={{
                                        position: 'absolute',
                                        top: '6px',
                                        right: '7px',
                                        color: '#fff',
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>

                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>{/* <InfoIcon sx={{ color: '#ffcc00' }} /><br /> */}Choose your image from below options</Typography>

                                <Stack flexDirection="row" sx={{ display: 'flex', gap: '20px', marginTop: '5%' }}>

                                    {/*  <Button
                            variant="contained"
                            onClick={() => handleDelete(deleteBlogId)}>
                            Yes
                        </Button> */}
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }} onClick={handleImageClick}>
                                        <ComputerIcon sx={{ fontSize: '3rem' }} />
                                        <p style={{ color: '#fff' }}>Choose from folder</p>
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            accept="image/*"
                                            style={{ /* width: '100%', */ display: 'none' }}
                                            onChange={handleImageChange}
                                        />
                                    </div>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                        <img src={unsplashImg} style={{ width: '28%', height: '48px',/* , marginTop: '2%' */ background: 'transparent' }} onClick={() => setOpenUnsplash(true)} />
                                        <p style={{ color: '#fff' }}>Choose from Unsplash</p>
                                    </div>
                                    {/* <Button
                            onClick={() => setDeleteModal(false)}
                            variant="contained"
                        sx={{ mr: 2, marginTop: '15%' }}
                        >
                            No
                        </Button> */}
                                </Stack>
                            </Box>
                        </Modal>

                        <Modal
                            open={openUnsplash}
                            onClose={() => setOpenUnsplash(false)}
                            aria-labelledby="child-modal-title"
                            aria-describedby="child-modal-description"
                        >
                            <Box
                                sx={{
                                    position: "absolute" as "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    transform: "translate(-50%, -50%)",
                                    width: isMobile ? "90%" : "54%",
                                    bgcolor: "#161b22",
                                    // border: "2px solid #000",
                                    // boxShadow: 24,
                                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 1.2)',
                                    pt: 2,
                                    px: 4,
                                    pb: 3,
                                    borderRadius: '10px',
                                    overflowY: isMobile ? 'auto' : 'hidden',
                                    height: isMobile ? '600px' : '650px',
                                    maxHeight: '650px'
                                }}
                            >
                                <div className="row" style={{ width: '100%', marginTop: '5%' }}>
                                    <div className=" col-sm-12 col-md-10 col-lg-10">
                                        <TextField
                                            placeholder="Search Unsplash images"
                                            size="small"
                                            InputLabelProps={{
                                                className: 'red-label'
                                            }}
                                            InputProps={{
                                                /*  ...params.InputProps, */
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            sx={{
                                                '& .MuiInputBase-input::placeholder': {
                                                    color: 'white',
                                                    opacity: 1
                                                },
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': { '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' }, backgroundColor: '#0d1117' },
                                                '& .MuiInputBase-input': { color: '#e5e7eb' },
                                                '& .MuiSvgIcon-root': { color: '#6b7280' }
                                            }}
                                            value={query}
                                            onChange={(e) => setQuery(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-sm-12 col-md-2 col-lg-2" style={{ marginTop: isMobile ? '2%' : '' }}>
                                        <Button variant="contained" onClick={handleSearch} sx={{ fontWeight: 'bold', width: isMobile ? '100%' : '' }}>Search</Button>
                                    </div>
                                    {/* <div className="col-md-8">
                        <Typography component="div">
                        <input
                            type="text"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            placeholder="Search Unsplash images"
                            style={{
                                width: '100%',
                                padding: '10px',
                                fontSize: '1rem',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                marginBottom: '1rem',
                            }}
                        />
                        </Typography>
                        </div>
                        <div className="col-md-4">
                        <Button variant="contained" onClick={handleSearch}>Search</Button>
                    </div> */}
                                </div>
                                {unsplashSearch === false ?
                                    <div className="row" style={{ width: '100%' }}>
                                        <div className="col-md-12">
                                            <img src={unsplash_logo} style={{ width: '10%', display: 'block', margin: '0 auto', marginTop: '17%' }}></img>
                                            <Typography variant="h4" sx={{ marginTop: '1%', textAlign: 'center', color: '#e5e7eb' }}>Unsplash</Typography>
                                            <Typography variant="h6" sx={{ marginTop: '1%', textAlign: 'center' }}>Try entering a search term, such as apple or daisy, to explore beautiful, high-resolution visuals.</Typography>{/* <br></br> */}

                                            <Typography variant="h6" sx={{ textAlign: 'center' }}>Once you've found an image you're happy with, click on it to add it to your workspace.</Typography>
                                            <Typography variant="h6" sx={{ textAlign: 'center' }} onClick={() => window.open('https://unsplash.com/', '_blank')}><a href="" style={{ textDecoration: 'none' }}>unsplash.com</a></Typography>
                                        </div>
                                    </div>
                                    :
                                    <div className="row" style={{ marginTop: '6%' }}>
                                        <div style={{
                                            display: 'grid',
                                            gridTemplateColumns: isMobile ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)',
                                            gap: '10px',
                                            justifyContent: 'center'
                                        }}/* style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }} */>
                                            {horizontalImages.map((image) => (
                                                <div key={image.id} className="thumbnail-container">
                                                    <img
                                                        className="thumbnail"
                                                        key={image.id}
                                                        src={modifyImageUrl(image.urls.thumb)}
                                                        alt={image.alt_description}
                                                        style={{ width: '100px', /* height: '100px', */ cursor: 'pointer', border: image.id === selectedUnsplashImg ? '3px solid #3b82f6' : '' }}
                                                        onClick={() => handleSelectUnsplashImage(image.urls.regular, image.id)}
                                                    />
                                                    <img
                                                        className="full-image"
                                                        src={image.urls.regular}
                                                        alt={image.alt_description}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                }

                                <div className="row" style={{ marginTop: '5%' }}>
                                    <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                                        <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={handleUnsplashselectionChange/* () => setOpenUnsplash(false) */}>Select</Button>
                                    </div>
                                    <div className={isMobile ? "col-6" : "col-sm-6 col-md-6 col-lg-6"}>
                                        <Button variant="contained" sx={{ fontWeight: 'bold' }} onClick={() => setOpenUnsplash(false)}>Close</Button>
                                    </div>
                                </div>
                            </Box>
                        </Modal>
                        {/* end unsplash and local image selection */}

                        {/* end modals */}
                    </div>
                </div>
            </div>
        </>
    );
}
